// @ts-check
/**
 * @file passwordPolicy.js
 * @location src/utils/passwordPolicy.js
 * @role 회원가입·비밀번호 재설정 양쪽에서 사용하는 단일 비밀번호 검증.
 *   한국 B2B SaaS 표준 — 「영문·숫자 포함 8자 이상」. 특수문자는 마찰 ↑ 대비 가치 낮아 미요구.
 */

/** @typedef {{ ok: true, message?: undefined } | { ok: false, message: string }} PasswordValidation */

/**
 * 비밀번호 정책 검증.
 * @param {string} password
 * @returns {PasswordValidation}
 */
export function validatePassword(password) {
  if (password.length < 8) {
    return { ok: false, message: '비밀번호는 8자 이상으로 설정해 주세요' };
  }
  if (!/[a-zA-Z]/.test(password)) {
    return { ok: false, message: '비밀번호에 영문을 포함해 주세요' };
  }
  if (!/\d/.test(password)) {
    return { ok: false, message: '비밀번호에 숫자를 포함해 주세요' };
  }
  return { ok: true };
}

/** UI 안내 카피 — 입력 필드 위 도움말 문구로 사용. */
export const PASSWORD_HINT = '영문·숫자 포함 8자 이상';
